import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { DialogService } from 'src/app/services/dialog.service';
import { HTTPService } from 'src/app/services/http.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ThemeService } from 'src/app/services/theme.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';

@Component({
    selector: 'app-copy-form-configuration',
    templateUrl: './copy-form-configuration.component.html',
    styleUrls: ['./copy-form-configuration.component.scss'],
    standalone: false
})
export class CopyFormConfigurationComponent implements OnInit {

  constructor(
              @Inject(MAT_DIALOG_DATA) public data, 
              public dialogRef:MatDialogRef<any>,
              public uas: UserAuthenticationServices,
              public dialogServices:DialogService,
              public snackBar:SnackbarService,
              public http:HTTPService,
              public ThemeService:ThemeService
              ) { }


  userSelected: any;
  usersData: any;
  tempUserData: any;
  tempUserDataDe: any;
  userInputFilter: any;
  userInputFilterDe: any;
  defaultQuery: any;
  selectedOptions = [];
  selectedOption;
  loadingDataUsers: boolean;
  /** spinner NG-ZORRO (substitui o ngx-spinner 'copyconfig') */
  copyLoading = false;
  entityName:string;
  userConfig:any;
  filter:any;
  sub1:Subscription;
  copyLayout = false;
  copyFilter = false;

  ngOnInit(): void {
    this.loadUsers(null);
    this.entityName = this.data.entityName;
    this.userConfig = this.data.userConfig;
    this.filter = this.data.filter;
  }

  ngOnDestroy(){
      if ( this.sub1!=null){this.sub1.unsubscribe();}
  }


  updateFilterUser(event) {
    let filterValue = null;
  
    if ( event == null || event ==''){
      this.tempUserData = this.usersData;  
      return;
    }
    
    if (event) {
      filterValue = (event.target as HTMLInputElement).value;
    }

    this.tempUserData = this.usersData.filter((data) => {
      let title:boolean = data.name.toString().toLowerCase().indexOf(filterValue.toLowerCase()) !== -1;      
      return  title;
    });
    
  }


  updateFilterUserDe(event) {
    let filterValue = null;
  
    if ( event == null || event ==''){
      this.tempUserDataDe = this.usersData;  
      return;
    }
    
    if (event) {
      filterValue = (event.target as HTMLInputElement).value;
    }

    this.tempUserDataDe = this.usersData.filter((data) => {
      let title:boolean = data.name.toString().toLowerCase().indexOf(filterValue.toLowerCase()) !== -1;      
      return  title;
    });
    
  }

  loadUsers(filterUser: any) {
    if (filterUser == null || filterUser.length == 0) {
      filterUser = null;
    }

    this.uas.getAllUsersCompany().then((x) => {
      this.usersData = this.uas.usersArr;
      this.tempUserData = this.uas.usersArr;
      this.tempUserDataDe = this.uas.usersArr;
      this.loadingDataUsers = false;
    });
  }

  cancelar(){
    this.dialogRef.close();
  }

  onNgModelChange(user) {
    // com nz-checkbox o [(ngModel)] já atualiza user.selected; só sincroniza a lista base
    this.selectedOption = user;
    let base = this.usersData.find(d=>d.id==user.id);
    if ( base != null ){
      base.selected = user.selected;
    }
  }


  getSelectedUsers(){
    if ( this.usersData == null || this.usersData.length == 0){
      return 0;
    }
    return this.usersData.filter(d=>d.selected).length;
  }

  finalizar(event: Event) {
    
    if( this.usersData.filter(d=>d.selected).length == 0){
      throw Error("Não existe nenhuma usuário selecionado.");
    }

    if ( !this.copyLayout && !this.copyFilter ){
      throw Error("Nenhuma opção de cópia selecionada.");
    }
    let c = '';
    if ( this.copyLayout &&  this.copyFilter ){
        c = 'Layout / Filtros';
    }else{
      if ( this.copyLayout && !this.copyFilter ){
        c = 'Layout';
      }else{
        c = 'Filtros';
      }
    }

    let message = `Todas as configurações de ${c} dos usuários selecionados serão perdidas. Deseja continuar?`;
    

    this.dialogServices.openNewDialog(message,()=>{
        this.copyLoading = true;
        this.getEntity(this.uas.user.iduser).then(async (idInstanceTable:any[])=>{
          if ( idInstanceTable !=null ){
            for ( var idInstanceVar of idInstanceTable){
              let idInstance = idInstanceVar['IDINSTANCE'];
              let instanceName = idInstanceVar['INSTANCENAME'];
              let type = idInstanceVar['TYPE'];
              let dataConfig = null;
              if ( type=='PARENT'){
                dataConfig = this.userConfig;
              }else{
                dataConfig = JSON.parse(idInstanceVar['CONFIG']);
              }

              let dataFilter = null;
              if ( type=='PARENT'){
                dataFilter = this.filter;
              }else{
                dataFilter = JSON.parse(idInstanceVar['FILTER']);
              }
              
              for ( var selected of this.usersData.filter(d=>d.selected)){
                await this.saveUser(idInstance,selected.id,selected.name, instanceName, dataConfig, dataFilter).then(msg=>{
                  this.snackBar.showSuccess(msg.toString())
                }).catch(error=>{
                  this.copyLoading = false;
                  throw error;
                }).finally(()=>{
                })
              }
            } 
            this.copyLoading = false;
            this.dialogRef.close("ok"); 
          
          }else{
            this.copyLoading = false;
            throw Error('Não foi possível determinar instância.');
          }   
        });
    },()=>{
        this.copyLoading = false;
        this.snackBar.showInformation("Processo cancelado pelo usuário.");
    })
  }

  async saveUser(idInstance,idUser,name,instanceName,dataConfig,dataFilter){
    return await new Promise((resolve, reject) => {
      let jsonSave: Object = {
        entityName: "Mktpusercfg",
        IDINSTANCE: idInstance,
        IDUSER: idUser
      };

      if ( this.copyFilter ){
        if ( dataFilter != null ){
          jsonSave['FILTER'] =  JSON.stringify(dataFilter);
        }
      }

      if ( this.copyLayout ){
        if ( dataConfig != null ){
          jsonSave['CONFIG'] =  JSON.stringify(dataConfig);
        }
        
      }

      this.sub1 = this.http.post(jsonSave, "JsonBrokerServices/save", true).subscribe( d=>{
          //this.snackBar.showSuccess(`Copia realizada com sucesso para o usuário ${name} para a instância ${instanceName}`)
          resolve(`Copia realizada com sucesso para o usuário ${name} para a instância ${instanceName}`);
      });
    });
  }


  async getEntity(idUser){
    return await new Promise((resolve, reject) => {
  
      let queryBuscaAcoes = {
        entityName: "Mktpdic",
        sql: `SELECT IDINSTANCE,INSTANCENAME, 'PARENT' TYPE, NULL CONFIG,NULL FILTER FROM MKTPDIC WHERE INSTANCENAME='${this.entityName}'
        UNION ALL
        SELECT X.IDINSTANCE, X.INSTANCENAME, 'CHILD' TYPE, CFG.CONFIG, CFG.FILTER
        
        FROM MKTPDIC  X INNER JOIN MKTPUSERCFG CFG ON CFG.IDINSTANCE=X.IDINSTANCE AND CFG.IDUSER= ${idUser}
        WHERE X.IDINSTANCE IN (SELECT DISTINCT IDINSTANCE FROM GETFULLREFERENCE('${this.entityName}',100))
        AND X.INSTANCENAME!='${this.entityName}'`
      };

      this.http
        .post(
          queryBuscaAcoes,
          "JsonBrokerServices/findnative",
          false,
          true,
          true
        )
        .subscribe((con) => {
            let idInstance = con["SQL"] as Object[];
            resolve(idInstance);
          });

      });
  }
  
}
